import React from "react";
import { connect } from "react-redux";
import { Redirect, Route } from "react-router";

const AuthRoute = props => {

  const { isAuthUser, role, userid, path, type } = props;
  const isAccounting = (role === "accounting") ? true : false;
  const isSupport = (role === "support") ? true : false;
  const isSalesOperator = (role === "salesoperator") ? true : false;
  const isSalesAdmin = (role === "salesadmin") ? true : false;
  const isDealerAdmin = (role === "dealeradmin") ? true : false;
  const isDealerOperator = (role === "dealeroperator") ? true : false;
  // console.log("Type of the auth User:---------->",type);

  if (!isAuthUser) {
    return path === "/login" || path == "/ssoCallback" ? <Route {...props} /> : <Redirect to="/login" />;
  }

  // Handle different route types
  switch (type) {
    case "guest":
      return (isAccounting || isSupport || isSalesOperator || isSalesAdmin || isDealerOperator) ? <Route {...props} /> : <Route {...props} />;

    case "accounting":
      return isAccounting ? <Route {...props} /> : <Redirect to="/login" />;
    
    case "salesoperator":
      return isSalesOperator ? <Route {...props} /> : <Redirect to="/login" />;

    case "salesadmin":
      return isSalesAdmin ? <Route {...props} /> : <Redirect to="/login" />;
      
    case "support":
      return isSupport ? <Route {...props} /> : <Redirect to="/login" />;

    case "dealeradmin":
      return isDealerAdmin ? <Route {...props} /> : <Redirect to="/login" />;

    case "dealeroperator":
      return isDealerOperator ? <Route {...props} /> : <Redirect to="/login" />;
      
    default:
      return <Route {...props} />;
  }
};

const mapStateToProps = ({ isAuthUser, role, userid }) => ({
  isAuthUser, 
  role, 
  userid
});

export default connect(mapStateToProps)(AuthRoute);